import { Profile } from './Plugins/_Profile';
import { Language } from './Plugins/_Language';
import { ThemeApp } from './Plugins/_ThemeApp';
import { HeaderUtilitiesProvider } from './_Hooks/useHeaderUtilities';
import { APP_SHELL_MENU } from '../../../../../_Config/AppShell.Layout';
import { useLanguage } from '../../../../Hooks/Contexts/Translate/useLanguageContext';


/*
    🔥 REGISTRO DE UTILIDADES

    Agregar una utilidad nueva (chat, soporte, atajos...) son DOS pasos:
      1. crear el componente con <UtilityDropdown id="chat" ...>
      2. agregar una línea a REGISTRY y otra a APP_SHELL_MENU.utilities

    Ni el hook ni el header se tocan.
*/

const LINKS = APP_SHELL_MENU.utilityLinks ?? {};

const REGISTRY = {
    language: (props) => <Language languages={props.languages} current={props.language} onChangeLanguage={props.onChangeLanguage} />,
    theme: (props) => <ThemeApp theme={props.theme} onChangeTheme={props.onChangeTheme} />,
    profile: (props) => <Profile user={props.user} links={props.profileLinks} onClickLogout={props.onClickLogout} />,
};

export const AppHeaderUtilities = ({
    isAuth = false,
    user = null,
    data = {},
    profileLinks = [],
    languages = [],
    language = null,
    onChangeLanguage = null,
    theme = null,
    onChangeTheme = null,
    onClickLogout = null,
}) => {

    const { useDataLanguage } = useLanguage();

    const PORTAL_LABEL = useDataLanguage.translations?.TEMPLATES?.header?.portal ?? APP_SHELL_MENU.portalLabel;

    const PROPS = {
        data, user, profileLinks, languages, language, portalLabel: PORTAL_LABEL,
        onChangeLanguage, theme, onChangeTheme, onClickLogout,
    };

    /*
        ⚠️ hideWhenAuth ES EL INVERSO DE requiresAuth

           requiresAuth: true  -> sólo con sesión (notificaciones, mensajes)
           hideWhenAuth: true  -> sólo SIN sesión (el acceso al portal)
    */
    const VISIBLE = APP_SHELL_MENU.utilities.filter((item) => (
        item.isEnabled
        && (!item.requiresAuth || isAuth)
        && (!item.hideWhenAuth || !isAuth)
        && REGISTRY[item.id]
    ));

    if (VISIBLE.length === 0) return null;

    return (
        <HeaderUtilitiesProvider>
            {VISIBLE.map((item) => <span key={item.id}>{REGISTRY[item.id](PROPS)}</span>)}
        </HeaderUtilitiesProvider>
    );
};